import { render } from "./SkillsSection.vue?vue&type=template&id=b97183ac&scoped=true"
import script from "./SkillsSection.vue?vue&type=script&lang=js"
export * from "./SkillsSection.vue?vue&type=script&lang=js"

import "./SkillsSection.vue?vue&type=style&index=0&id=b97183ac&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b97183ac"]])

export default __exports__